<template>
  <div class="beCareful">

    <ul class="beCareful_ul">
      <li v-if="$route.query.appointType === '0'">
        <h3>体检是人们做好预防保健工作的一项重要举措。在进行体检时，应注意以下几项：</h3>
        1.体检前必须空腹，应在体检前一晚10:00过后禁食，可以饮水，但是不能喝牛奶、豆浆等含有糖分的饮料。检查当天需抽完血、做完腹部超音波检查后，方可进食。<br/>
        2.体检前3天不要大鱼大肉，忌酒，不要吃过于油腻的高蛋白、高脂肪的食物，也不要过于剧烈的活动，会导致体检的结果出现偏差。避免使用对肝肾功能有影响的药物。<br/>
        3.体检时要着穿脱方便的服装、鞋袜，最好不佩戴项链等，女同志的文胸不要带钢托，不要穿金属亮片的内衣。<br/>
        4.女士生理期，不宜作妇科检查及尿检;做妇科检查前应排空膀胱;乳腺远红外线复查最好选择在生理期后一周内。未婚女士不宜做妇科检查,有特殊需求者要签署相关协议(告知书)方可进行相应检查。<br/>
        5.做膀胱、前列腺、子宫、附件B超时，需要憋排尿。<br/>
        6.为避免血压波动发生危险，高血压患者应在服完降压药后再来体检。糖尿病或其他慢性病患者，也应在采血后及时服药，不可因体检而干扰常规治疗。<br/>
      </li>
      <li v-if="$route.query.appointType === '1'">
        <h3>胃镜检查注意事项：</h3>
        1.体检者应该查乙肝表面抗原、胸片、心电图等，如果有严重的心肺疾病，不建议做胃镜检查。<br/>
        2.胃镜需要空腹检查，检查前一天的饮食以清淡饮食为主，检查前半个小时左右尽量不要喝水。<br/>
        3.糖尿病患者可以带一些糖块类食物，防止出现低血糖。心脏病、高血压的患者，要在医生的指导下，停用抗凝药一段时间，让凝血功能恢复到大致正常，再做胃镜查。<br/>
        4.胃镜检查过程中要按医嘱进行吞咽动作，可以有效的缓解恶心干呕等反应。<br/>
        5.检查后，半小时内不要喝水和吃东西，避免引起呛咳。当天宜清淡饮食，忌辛辣，次日可以恢复正常的饮食，但还是尽量避免坚硬、刺激性食物。<br/>
        6.胃镜后尽量卧床休息两到三个小时， 24小时内不能做剧烈运动。<br/>
      </li>
      <li v-if="$route.query.appointType === '1'">
        <h3>肠镜检查注意事项:</h3>
        1.检查前3天，进食低脂少渣饮食（如稀饭、面条、蒸鸡蛋等）。避免食用水果、蔬菜、全谷类和肉类。<br/>
        2.检查前2天，不要吃深色食物，避免影响肠镜观察。<br/>
        3.肠镜检查前需要禁食8小时、禁饮6小时。因此，检查前1晚进食清流质饮食后，就不能吃任何东西了。<br/>
        4.检查前一晚进行肠道准备工作，按医嘱服用泻药，使排出的粪便为清亮水样、无明显粪渣的状态。<br/>
        5.高血压病人，需服用降压药使血压正常。服用抗凝药物者需要提前告知医生。<br/>
        6.检查时需要穿宽松的衣裤。<br/>
        7.女性在经期需要谨慎，告知医生，由医生决定是否进行肠镜。<br/>
        8.检查后，若无腹痛、腹胀，可进食易消化的食物。如腹痛、腹胀明显，持续不能缓解或进行性加重，请您立即告知医生。<br/>
        9.如做了病理学检查或手术，需要卧床休息，3天内避免剧烈运动，1周内避免负重。<br/>
      </li>
    </ul>

  </div>
</template>

<script>
export default {
  name: "beCareful",
  data() {
    return {

    }
  },
  created() {

  },
  mounted() {

  },
  methods: {

  }
}
</script>

<style lang="less" scoped>
  .beCareful{
    padding: 1.25rem;
    overflow-y: auto;
    .beCareful_ul{
      li{
        margin-bottom: 1.25rem;
        h3{
          margin-bottom: 0.625rem;
        }
      }
    }
    .beCareful_ul li:nth-last-child(1) {
      margin-bottom: 0;
    }
  }
</style>
